module.exports = __webpack_public_path__ + "img/configure-benefits-hover.7e1cdfab.svg";